import { DataScienceEnums } from 'dashboard-services/api/dataScience';
import { StatusesEnums } from 'dashboard-services/api/statuses';
import { ActionService, CommonService } from 'dashboard-services/services';
import { DashboardLinkFactory } from 'ng-common-features/urlBuilder';

import { builderPipelineCreatorActions, saveDialogPipelineCreatorActions } from 'actions/modules/datascience';
import { routing } from 'routing';

export default (() => {

  const ARRAY_VALUE_TYPES = [
    DataScienceEnums.TASK_PARAM_VALUE_TYPE.SELECT,
    DataScienceEnums.TASK_PARAM_VALUE_TYPE.MULTI_SELECT,
    DataScienceEnums.TASK_PARAM_VALUE_TYPE.SYMBOL_COLUMN,
    DataScienceEnums.TASK_PARAM_VALUE_TYPE.MULTI_SYMBOL_COLUMN,
    DataScienceEnums.TASK_PARAM_VALUE_TYPE.SYMBOL_KEY,
    DataScienceEnums.TASK_PARAM_VALUE_TYPE.MULTI_SYMBOL_KEY,
    DataScienceEnums.TASK_PARAM_VALUE_TYPE.SYMBOL_VALUE,
    DataScienceEnums.TASK_PARAM_VALUE_TYPE.MULTI_SYMBOL_VALUE,
    DataScienceEnums.TASK_PARAM_VALUE_TYPE.EMAIL,
    DataScienceEnums.TASK_PARAM_VALUE_TYPE.HOLIDAY_CALENDAR
  ]

  const init = (navigate, groupName, pipelineName, version, getPipelineCall) => dispatch => {
    dispatch(cleanAll())
    if(!pipelineName) {
      return dispatch(setSaved(true))
    }
    return getPipelineCall({ pipelineName, groupName, version })
      .then(response => {
        dispatch(setPipelineId(response.pipeline.id))
        dispatch(saveDialogPipelineCreatorActions.onChange(response.pipeline.markdownId, 'markdownId'))
        dispatch(builderPipelineCreatorActions.setComments(CommonService.isJson(response.payload) && JSON.parse(response.payload || "{}").comments))
        dispatch(saveDialogPipelineCreatorActions.onChange(pipelineName, "name"))
        dispatch(saveDialogPipelineCreatorActions.onChange(version, "version"))
        dispatch(saveDialogPipelineCreatorActions.onChange(response.pipeline.version, "versionRaw"))
        dispatch(saveDialogPipelineCreatorActions.onChange(response.pipeline.latest, "latest"))
        dispatch(saveDialogPipelineCreatorActions.onChange(response.pipeline.lastChangeBy, "lastChangeBy"))
        dispatch(saveDialogPipelineCreatorActions.onChange({ label: response.pipeline.groupName, value: response.pipeline.groupName }, "groupName"))
        dispatch(saveDialogPipelineCreatorActions.onChange(response.pipeline.tags, "tags"))
        dispatch(saveDialogPipelineCreatorActions.onChange(response.pipeline.trigger, "trigger"))
        return response;
      })
      .catch(response => {
        navigate(DashboardLinkFactory.dataScience.list({ baseUrl: "", tab: routing.dataScience.routing.list.hashes.pipelines }))
        return response
      })
  }

  const ON_CHANGE = 'ON_CHANGE_BASIC_CREATOR_DATA_SCIENCE'
  const onChange = ActionService.makeActionCreator(ON_CHANGE, 'value', 'name')

  const CLEAN_ALL = 'CLEAN_ALL_CREATOR_DATA_SCIENCE'
  const cleanAll = ActionService.makeActionCreator(CLEAN_ALL)
  
  const GET_TASKS_FOR_CATEGORY = 'GET_TASKS_FOR_CATEGORY_CREATOR_DATA_SCIENCE'
  const getTasksForCategoryResponse = ActionService.makeActionCreator(GET_TASKS_FOR_CATEGORY, 'tasks', 'category')
  
  const ADD_TASKS_TO_CATEGORIES = 'ADD_TASKS_TO_CATEGORIES_CREATOR_DATA_SCIENCE'
  const addTasksToCategoryResponse = ActionService.makeActionCreator(ADD_TASKS_TO_CATEGORIES, 'tasks')

  const SET_PIPELINE_ID = 'SET_PIPELINE_ID_CREATOR_DATA_SCIENCE'
  const setPipelineId = ActionService.makeActionCreator(SET_PIPELINE_ID, 'id')

  const SET_SAVED = 'SET_SAVED_CREATOR_DATA_SCIENCE'
  const setSaved = ActionService.makeActionCreator(SET_SAVED, 'value')

  const SET_EXECUTING = 'SET_EXECUTING_CREATOR_DATA_SCIENCE'
  const setExecuting = ActionService.makeActionCreator(SET_EXECUTING, 'executing')

  const SET_PAUSED = 'SET_PAUSED_CREATOR_DATA_SCIENCE'
  const setPaused = ActionService.makeActionCreator(SET_PAUSED, 'paused')

  const SET_STATUSES = 'SET_STATUSES_CREATOR_DATA_SCIENCE'
  const setStatuses = ActionService.makeActionCreator(SET_STATUSES, 'items')

  const SET_COMMENTS_VISIBLE = 'SET_COMMENTS_VISIBLE_CREATOR_DATA_SCIENCE'
  const setCommentsVisible = ActionService.makeActionCreator(SET_COMMENTS_VISIBLE, 'value')
  
  const SET_FOOTER_EXPANDED = 'SET_FOOTER_EXPANDED_CREATOR_DATA_SCIENCE'
  const setFooterExpanded = ActionService.makeActionCreator(SET_FOOTER_EXPANDED, 'value')

  const SET_ADD_TASK_EXPANDED = 'SET_ADD_TASK_EXPANDED_CREATOR_DATA_SCIENCE'
  const setAddTaskExpanded = ActionService.makeActionCreator(SET_ADD_TASK_EXPANDED, 'value')

  const SET_STATUS_VERSION = 'SET_STATUS_VERSION_CREATOR_DATA_SCIENCE'
  const setStatusVersion = ActionService.makeActionCreator(SET_STATUS_VERSION, 'value')

  const hasAccessProblems = tasks => {
    const hasProblems = Object.values(tasks).findIndex(task => 
      (task.params || []).findIndex(param => {
        if((param.valueType === DataScienceEnums.TASK_PARAM_VALUE_TYPE.GROUP || param.valueType === DataScienceEnums.TASK_PARAM_VALUE_TYPE.GROUP_READ) && String(param.value).startsWith("{ID:")) {
          return true;
        }
        return false;
      }) > -1) > -1
    return hasProblems
  }

  const BRING_TO_FRONT = 'BRING_TO_FRONT_BASIC_CREATOR_DATA_SCIENCE'
  const bringToFront = ActionService.makeActionCreator(BRING_TO_FRONT, 'value')

  const SET_PAUSED_EDITED_FILES = 'SET_PAUSED_EDITED_FILES_BASIC_CREATOR_DATA_SCIENCE'
  const setPausedEditedFiles = ActionService.makeActionCreator(SET_PAUSED_EDITED_FILES, 'value')

  const ADD_PAUSED_EDITED_FILE = 'ADD_PAUSED_EDITED_FILE_BASIC_CREATOR_DATA_SCIENCE'
  const addPausedEditedFile = ActionService.makeActionCreator(ADD_PAUSED_EDITED_FILE, 'value')

  const computeTaskStatus = (nodeId, allStatuses) => {
    const thisStatus = allStatuses.find(s => s.payload?.nodeId === nodeId)
    if(thisStatus?.status === StatusesEnums.STATUS.PAUSED) {
      return StatusesEnums.STATUS.PAUSED
    }
    const results = []
    if(!thisStatus) {
      return thisStatus;
    }
    const queuedEIds = [thisStatus.eId]
    const visitedEIds = []

    while(queuedEIds.length > 0) {
      const currentEId = queuedEIds.shift()

      if(!visitedEIds.includes(currentEId)) {
        visitedEIds.push(currentEId)
        const newStatuses = allStatuses.filter(status => status.prevEId === currentEId)
        results.push(...newStatuses)
        queuedEIds.push(...newStatuses.map(s => s.eId))
      }
    }
    if(results.length === 0) {
      return thisStatus?.status
    }
    if(results.findIndex(r => r.status === StatusesEnums.STATUS.ERROR) > -1 || thisStatus?.status === StatusesEnums.STATUS.ERROR) {
      return StatusesEnums.STATUS.ERROR;
    }
    if(results.findIndex(r => r.status === StatusesEnums.STATUS.RUNNING) > -1 || thisStatus?.status === StatusesEnums.STATUS.RUNNING) {
      return StatusesEnums.STATUS.RUNNING;
    }
    if(results.findIndex(r => r.status === StatusesEnums.STATUS.WARN) > -1 || thisStatus?.status === StatusesEnums.STATUS.WARN) {
      return StatusesEnums.STATUS.WARN;
    }
    if(results.findIndex(r => r.status === StatusesEnums.STATUS.PAUSED) > -1 || thisStatus?.status === StatusesEnums.STATUS.PAUSED) {
      return StatusesEnums.STATUS.PAUSED;
    }
    if(results.findIndex(r => r.status === StatusesEnums.STATUS.PENDING) > -1 || thisStatus?.status === StatusesEnums.STATUS.PENDING) {
      return StatusesEnums.STATUS.PENDING;
    }
    if(results.findIndex(r => r.status === StatusesEnums.STATUS.UNEXECUTED) > -1 || thisStatus?.status === StatusesEnums.STATUS.UNEXECUTED) {
      return StatusesEnums.STATUS.UNEXECUTED;
    }
    if(results.findIndex(r => r.status === StatusesEnums.STATUS.INFO) > -1 || thisStatus?.status === StatusesEnums.STATUS.INFO) {
      return StatusesEnums.STATUS.INFO;
    }
    return StatusesEnums.STATUS.UNEXECUTED
  }

  const setUpEmptyGroup = (groups, groupName) => {
    if (!groups[groupName]) {
      groups[groupName] = { tasks: [] }
    }
  }

  const addGroupToGroups = (groups, groupName, task, param, id) => {
    setUpEmptyGroup(groups, groupName)
    const taskIndex = groups[groupName].tasks.findIndex(localTask => localTask.id === task.id)
    if (taskIndex === -1) {
      groups[groupName].tasks.push({
        id,
        readableName: task.readableName,
        params: []
      })
    }
    groups[groupName].tasks[taskIndex > -1 ? taskIndex : groups[groupName].tasks.length - 1].params.push(param)
  }
  const VALUE_TYPES_INCLUDING_GROUP = [DataScienceEnums.TASK_PARAM_VALUE_TYPE.DATA_PREP_PARAM, DataScienceEnums.TASK_PARAM_VALUE_TYPE.DATALAKE_FILE, DataScienceEnums.TASK_PARAM_VALUE_TYPE.SYMBOL, DataScienceEnums.TASK_PARAM_VALUE_TYPE.PIPELINE, DataScienceEnums.TASK_PARAM_VALUE_TYPE.SYMBOL_FILTER, DataScienceEnums.TASK_PARAM_VALUE_TYPE.MULTI_SYMBOL_FILTER]
  const VALUE_TYPES_BEEING_GROUP = [DataScienceEnums.TASK_PARAM_VALUE_TYPE.GROUP, DataScienceEnums.TASK_PARAM_VALUE_TYPE.GROUP_READ]

  const getAllGroups = tasks => {
    const groups = {}
    Object.entries(tasks || {}).forEach(([id, task]) => {
      setUpEmptyGroup(groups, task.groupName)
      groups[task.groupName].isTaskGroup = true;
      groups[task.groupName].tasks.push({
        id,
        readableName: task.readableName,
        params: []
      })
      task.params.forEach(param => {
        if(VALUE_TYPES_INCLUDING_GROUP.includes(param.valueType) && typeof(param.value) === "object") {
          const groupName = param.value?.groupName;
          if(groupName) {
            addGroupToGroups(groups, groupName, task, param, id)
          }
        } else if(VALUE_TYPES_BEEING_GROUP.includes(param.valueType)) {
          const groupName = param.value
          if(groupName) {
            addGroupToGroups(groups, groupName, task, param, id)
          }
        }
      })
    })
    return Object.entries(groups).map(([key, value]) => ({ name: key, ...value })).sort((a, b) => {
      if(a.isTaskGroup === b.isTaskGroup) {
        return a.name.localeCompare(b.name)
      }
      return a.isTaskGroup ? 1 : -1
    })
  }

  const isDynamicParameter = paramValue => {
    if(paramValue === undefined || paramValue === null || paramValue === "") {
      return false;
    }
    if(String(paramValue).length !== 39) {
      return false;
    }
    return String(paramValue).match(/\$\{[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\}/) !== null
  }

  const generateDynamicId = () => "${" + CommonService.generateUID() + "}"

  return {
    init,
    SET_PIPELINE_ID,
    GET_TASKS_FOR_CATEGORY,
    setPipelineId,
    cleanAll,
    CLEAN_ALL,
    SET_SAVED,
    setSaved,
    SET_EXECUTING,
    setStatuses,
    SET_STATUSES,
    SET_COMMENTS_VISIBLE,
    setCommentsVisible,
    setFooterExpanded,
    SET_FOOTER_EXPANDED,
    SET_ADD_TASK_EXPANDED,
    setAddTaskExpanded,
    SET_STATUS_VERSION,
    hasAccessProblems,
    BRING_TO_FRONT,
    bringToFront,
    setPaused,
    SET_PAUSED,
    computeTaskStatus,
    SET_PAUSED_EDITED_FILES,
    setPausedEditedFiles,
    ADD_PAUSED_EDITED_FILE,
    addPausedEditedFile,
    onChange,
    ON_CHANGE,
    getAllGroups,
    VALUE_TYPES_BEEING_GROUP,
    VALUE_TYPES_INCLUDING_GROUP,
    ARRAY_VALUE_TYPES,
    isDynamicParameter,
    generateDynamicId,
    setExecuting,
    setStatusVersion,
    getTasksForCategoryResponse,
    ADD_TASKS_TO_CATEGORIES,
    addTasksToCategoryResponse
  }
})()
